<template>
  <div class="page-not-found">
    <div class="top-block">
      <div class="line">
        <div class="w-12 text-center error-title">
          <h2>Síða fannst ekki</h2>
        </div>
      </div>
      <div class="line">
        <div class="w-12">
          <div class="line">
            <div class="w-6" style="margin: 0 auto">
              <img src="https://i.imgur.com/gP9sN.gif" style="width: 100%;">
            </div>
          </div>
        </div>
      </div>
      <div class="line" style="margin-top: 75px;">
        <div class="w-12 text-center">
          <router-link class="bl-btn bl-primary-btn home-btn" :to="homeUrl">
                <span style="vertical-align: top; margin: 0 12px 0 0;">
                  <svg width="31" height="8" viewBox="0 0 31 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M0.646444 3.64645C0.451183 3.84171 0.451183 4.15829 0.646444 4.35356L3.82842 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17158C4.73079 0.976313 4.73079 0.659731 4.53553 0.464468C4.34027 0.269206 4.02369 0.269206 3.82842 0.464468L0.646444 3.64645ZM31 3.5L0.999998 3.5L0.999998 4.5L31 4.5L31 3.5Z"
                      fill="white"/>
                </svg>
                </span>
            Fara á forsíðu vefsins
          </router-link>
        </div>
      </div>
      <div class="line" style="margin-top: 45px;">
        <div class="w-12 text-center error-help-text">
          Allar ábendingar um efni eða það sem betur má fara á vefnum eru þegnar með þökkum <a
            href="mailto:bilaskra@bilaskra.is" class="bl-blue">bilaskra@bilaskra.is</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      homeUrl: '',
    }
  },
  mounted() {
    let controller = this.$route.params.controller || 'nyir-bilar';
    this.homeUrl = '/' + controller;
  }
}
</script>